export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.ovo.energy';
export const APP_STORE_URL =
  'https://apps.apple.com/gb/app/ovo-energy/id626316021';
